import React from 'react';
import FaqForm from '../../Containers/FaqForm';
import FaqList from '../../Containers/FaqList';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import ModalLogin from '../../Containers/Modal_Login';
import ModalRegister from '../../Containers/Modal_Register';
import ModalSuccess from '../../Containers/ModalSuccess';
import ModalResult from '../../Containers/ModalResult';

const FaqPage = () => {
  return (
    <div className='faq-page'>
      <Header />
      <main>
        <div className='faq'>
          <div className='container'>
            <div className='header'>
              <h2 className='title'>
                <span className='black'>Giải đáp</span>{' '}
                <span className='red'>thắc mắc</span>
              </h2>
              <p className='des'>
                Giải đáp thắc mắc của bạn về kiến thức chuyển đổi số
              </p>
            </div>
            <FaqList />
            <FaqForm />
          </div>
        </div>
        <ModalLogin />
        <ModalRegister />
        <ModalSuccess />
        <ModalResult
          title='Gửi câu hỏi thành công!'
          subtitle='Chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất.'
        />
      </main>
      <Footer />
    </div>
  );
};
export default FaqPage;
